import type { LTWHP, Page } from "../types";
import { optimizeClientRects } from "./optimize-client-rects";

const isClientRectInsidePageRect = (clientRect: DOMRect, pageRect: DOMRect) => {
    if (clientRect.top < pageRect.top) {
        return false;
    }
    if (clientRect.bottom > pageRect.bottom) {
        return false;
    }
    if (clientRect.right > pageRect.right) {
        return false;
    }
    if (clientRect.left < pageRect.left) {
        return false;
    }

    return true;
};

export const getClientRects = (
    range: Range,
    pages: Page[],
    shouldOptimize = true,
): Array<LTWHP> => {
    const clientRects = Array.from(range.getClientRects());

    const rects = clientRects.flatMap((clientRect) =>
        pages
            .map((page) => {
                const pageRect = page.node.getBoundingClientRect();

                if (
                    isClientRectInsidePageRect(clientRect, pageRect) &&
                    clientRect.width > 0 &&
                    clientRect.height > 0 &&
                    clientRect.width < pageRect.width &&
                    clientRect.height < pageRect.height
                ) {
                    return {
                        top: clientRect.top + page.node.scrollTop - pageRect.top,
                        left: clientRect.left + page.node.scrollLeft - pageRect.left,
                        width: clientRect.width,
                        height: clientRect.height,
                        pageNumber: page.number,
                    } as LTWHP;
                }
                return null;
            })
            .filter((rect): rect is LTWHP => rect !== null),
    );

    return shouldOptimize ? optimizeClientRects(rects) : rects;
};